import React from 'react';
import { LabelText, ValueText } from '../atoms/Typography';

/**
 * Data point molecule — label above value (e.g. Departments / 03).
 */
export default function DataPoint({ label, value, icon, className = '' }) {
  const display =
    value === null || value === undefined
      ? '—'
      : typeof value === 'number'
        ? String(value).padStart(2, '0')
        : value;

  return (
    <div className={`ca-data-point ${className}`.trim()}>
      {icon ? <span className="ca-data-point__icon" aria-hidden="true">{icon}</span> : null}
      <ValueText>{display}</ValueText>
      <span className="ca-data-point__label">{label}</span>
    </div>
  );
}
